import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { IntegrationType } from "@/payments/integrations/const";
import paymentComponent from "../../components/DefaultPaymentComponent.vue";
import { IntegrationModule } from "../types";
import { createRejectError, makePurchase, getUrls, PAYMENT_ERROR_MESSAGES, TIMEOUT_TO_CLOSE } from "../utils";

const integrationModule: IntegrationModule<never> = {
  paymentComponent,
  purchase: data =>
    new Promise(async (resolve, reject) => {
      try {
        let timeout: ReturnType<typeof setTimeout>;
        const subscription = await providers.PaymentSystemsProvider.subscribeDepositPurchase(t => {
          timeout && clearTimeout(timeout);
          subscription.unsubscribe();
          resolve({ status: true, subjectPurchased: false, transaction: t });
        });
        try {
          await makePurchase(() =>
            providers.CryptoComPurchaseProvider.getDepositUrl({
              data: {
                ...getUrls("/payments/cryptocom/thankyou.html"),
                ...data,
              },
            })
          ).catch(e => {
            if (e.message === PAYMENT_ERROR_MESSAGES.VERIFY_TRANSACTION) {
              timeout = setTimeout(() => {
                subscription.unsubscribe();
                reject(createRejectError(e));
              }, TIMEOUT_TO_CLOSE);
            } else throw e;
          });
        } catch (e) {
          subscription.unsubscribe();
          reject(createRejectError(e));
        }
      } catch (e) {
        reject(createRejectError(e));
      }
    }),
  subscribe: data =>
    new Promise(async (resolve, reject) => {
      try {
        let timeout: ReturnType<typeof setTimeout>;
        const subscription = await providers.PaymentSystemsProvider.subscribeRecurringPurchase(s => {
          timeout && clearTimeout(timeout);
          subscription.unsubscribe();
          resolve({
            status: true,
            subjectPurchased: false,
            subscription: s,
          });
        });
        try {
          await makePurchase(() =>
            providers.CryptoComPurchaseProvider.getRecurringUrl({
              data: {
                ...getUrls("/payments/thankyou.html"),
                ...data,
              },
            })
          ).catch(e => {
            if (e.message === PAYMENT_ERROR_MESSAGES.VERIFY_TRANSACTION) {
              timeout = setTimeout(() => {
                subscription.unsubscribe();
                reject(createRejectError(e));
              }, TIMEOUT_TO_CLOSE);
            } else throw e;
          });
        } catch (e) {
          subscription.unsubscribe();
          reject(createRejectError(e));
        }
      } catch (e) {
        reject(createRejectError(e));
      }
    }),
  allowSaveCard: false,
  name: $t("CryptoCom"),
  logo: "/img/paymentSystems/crypto_com.svg",
  type: IntegrationType.CRYPTO,
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "cryptocom" ?? false;
};

export default integrationModule;
